/**
 * RTWO Cryptography & Identity Engine — secp256k1 Key Provider
 */

import type { KeyProviderType } from '../adapters/key-provider-interface';
import { AlgorithmKeyProvider } from './algorithm-key-provider';

export class Secp256k1KeyProvider extends AlgorithmKeyProvider {
  readonly providerId = 'secp256k1-key-provider';
  readonly providerName = 'secp256k1 Key Provider';
  readonly providerType: KeyProviderType = 'secp256k1';
  protected readonly supportedAlgorithm = 'secp256k1' as const;
  protected readonly supportedCurve = 'secp256k1' as const;
}
